module.exports = __webpack_public_path__ + "static/img/SMS.b8ae7fcb.png";